import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaExternalLinkAlt, FaGithub, FaEye, FaCode, FaMobile, FaPalette } from 'react-icons/fa';
import './Portfolio.css';

const Portfolio = () => {
  const [activeFilter, setActiveFilter] = useState('all');

  const projects = [
    
    {
      id: 1,
      title: "Hotel Revenue Management – The Byke Hotels",
      category: "web",
      image: "/thebiky.png",
      description: "Dynamic pricing engine with Node.js + React; integrates Winhms PMS, role-based access, seasonal/occupancy/lead-time rules, and real-time optimization.",
      technologies: ["Node.js", "React", "MongoDB", "Winhms PMS", "REST APIs"],
      liveUrl: "#",
      githubUrl: "#",
      featured: true
    },
    // {
    //   id: 2,
    //   title: "RanBazaar – Customized Gifts E‑commerce",
    //   category: "web",
    //   image: "https://images.unsplash.com/photo-1519861531473-9200262188bf?auto=format&fit=crop&w=1200&q=80",
    //   description: "Scalable store handling 3k+ daily orders, JustPay integration, bulk PDF invoicing/labels via Puppeteer for streamlined fulfillment.",
    //   technologies: ["React", "Node.js", "MongoDB", "JustPay", "Puppeteer"],
    //   liveUrl: "https://ranbazaar.com/",
    //   githubUrl: "#",
    //   featured: true
    // },
    {
      id: 3,
      title: "Ktws School Uniform",
      category: "web",
      image: "/ktws.png",
      description: "Sales Smart, long-lasting uniforms to keep students looking sharp every day. Premium quality school uniforms designed for comfort, durability, and style",
      technologies: ["Wordpress", "MySQL", "Payu"],
      liveUrl: "https://www.abhiraj.org/ktws/",
      githubUrl: "#",
      featured: false
    },
    // {
    //   id: 4,
    //   title: "Tambola House – Live Multiplayer Gaming",
    //   category: "web",
    //   image: "https://images.unsplash.com/photo-1603816245457-9b1319bd137a?auto=format&fit=crop&w=1200&q=80",
    //   description: "Real‑time streaming, prediction games, and chat; socket optimization and scalable infra for thousands of concurrent users.",
    //   technologies: ["Node.js", "Socket.io", "Redis", "React", "WebRTC"],
    //   liveUrl: "#",
    //   githubUrl: "#",
    //   featured: true
    // },
    {
      id: 5,
      title: "Chat application",
      category: "web",
      image: "/codexachat.png",
      description: "It sounds like you need a dedicated customer support chat application that is completely independent of WhatsApp, allowing you to manage a high volume of client issues, maintain excellent records, and effectively organize your support staff without the risk of being blocked.",
      technologies: ["Node.js", "React", "Socket.io", "Kubernetes"],
      liveUrl: "#",
      githubUrl: "#",
      featured: false
    },
    {
      id: 6,
      title: "Nuflex – flutter + Node.js + MongoDB",
      category: "app",
      image: "/nuflex.webp",
      description: "Nuflex, the largest manufacturer of mattresses, sofa seats, and more, now offers an app for retailers to redeem points and access exclusive services.",
      technologies: ["flutter", "Node.js", "MongoDB"],
      liveUrl: "https://play.google.com/store/apps/details?id=com.nuflex.techvision",
      githubUrl: "#",
      featured: false
    },
    {
      id: 7,
      title: "Gsf security",
      category: "web",
      image: "/gsfsecurtiy.png",
      description: "GSF is leading security company which provides lot of services.",
      technologies: ["Wordpress", "MySQl"],
      liveUrl: "https://gsfsecurity.com/",
      githubUrl: "#",
      featured: false
    },
    {
      id: 8,
      title: "Workgearz",
      category: "web",
      image: "/workgearz.png",
      description: "Work Gearz offers ultimate resources for work and safety, providing a comprehensive collection of information to help you stay protected and informed on the job.",
      technologies: ["WordPress","PHP", "MYSQL"],
      liveUrl: "https://workgearz.com/",
      githubUrl: "#",
      featured: false
    },
    {
      id: 9,
      title: "Weldgears",
      category: "web",
      image: "/welgears.png",
      description: "Welgear is maximize your potential with the right welding tips and high-quality tools. Prioritize your well-being with essential safety gear, ensuring every welding experience is both productive and safe.",
      technologies: ["WordPress", "PHP", "SEO"],
      liveUrl: "https://weldgears.com/",
      githubUrl: "#",
      featured: false
    },
    {
      id: 2,
      title: "Essential Trunk – E‑commerce Platform",
      category: "web",
      image: "/essentialtrunk.png",
      description: "Essential trunk began with a thoughtful idea to deliver a curated collection of must-have jewelry and accessories that are trend - forward, chic, & timeless.",
      technologies: ["Shopify"],
      liveUrl: "https://essentialtrunk.com/",
      githubUrl: "#",
      featured: true
    },
  ];

  const filters = [
    { key: 'all', label: 'All Projects', icon: <FaEye /> },
    { key: 'web', label: 'Web Development', icon: <FaCode /> },
    { key: 'mobile', label: 'Mobile Apps', icon: <FaMobile /> },
    { key: 'design', label: 'UI/UX Design', icon: <FaPalette /> }
  ];

  const filteredProjects = activeFilter === 'all' 
    ? projects 
    : projects.filter(project => project.category === activeFilter);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };

  return (
    <section id="portfolio" className="portfolio">
      <div className="container">
        <motion.div
          className="section-header"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <span className="section-badge">Our Portfolio</span>
          <h2 className="section-title">
            Showcase of <span className="gradient-text">Our Best Work</span>
          </h2>
          <p className="section-description">
            Explore our diverse portfolio of successful projects across web development, 
            mobile applications, and UI/UX design.
          </p>
        </motion.div>

        {/* <motion.div
          className="portfolio-filters"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          viewport={{ once: true }}
        >
          {filters.map((filter) => (
            <motion.button
              key={filter.key}
              className={`filter-button ${activeFilter === filter.key ? 'active' : ''}`}
              onClick={() => setActiveFilter(filter.key)}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              {filter.icon}
              {filter.label}
            </motion.button>
          ))}
        </motion.div> */}

        <motion.div
          className="portfolio-grid"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <AnimatePresence mode="wait">
            {filteredProjects.map((project) => (
              <motion.div
                key={project.id}
                className={`project-card ${project.featured ? 'featured' : ''}`}
                variants={itemVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
                layout
                whileHover={{ y: -10 }}
                exit={{ opacity: 0, scale: 0.8 }}
                transition={{ duration: 0.3 }}
              >
                <div className="project-image">
                  <img src={project.image} alt={project.title} />
                  <div className="project-overlay">
                    <div className="project-actions">
                      <motion.a
                        href={project.liveUrl}
                        className="action-button"
                        whileHover={{ scale: 1.1 }}
                        whileTap={{ scale: 0.9 }}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <FaExternalLinkAlt />
                      </motion.a>
                      <motion.a
                        href={project.githubUrl}
                        className="action-button"
                        whileHover={{ scale: 1.1 }}
                        whileTap={{ scale: 0.9 }}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <FaGithub />
                      </motion.a>
                    </div>
                  </div>
                  {project.featured && (
                    <div className="featured-badge">Featured</div>
                  )}
                </div>

                <div className="project-content">
                  <h3 className="project-title">{project.title}</h3>
                  <p className="project-description">{project.description}</p>
                  
                  <div className="project-technologies">
                    {project.technologies.map((tech, index) => (
                      <span key={index} className="tech-tag">
                        {tech}
                      </span>
                    ))}
                  </div>
                </div>
              </motion.div>
            ))}
          </AnimatePresence>
        </motion.div>

        <motion.div
          className="portfolio-cta"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          viewport={{ once: true }}
        >
          <div className="cta-content">
            <h3>Have a Project in Mind?</h3>
            <p>Let's create something amazing together. Get in touch to discuss your ideas.</p>
            <motion.button
              className="cta-button"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={() => {
                const element = document.getElementById('contact');
                if (element) {
                  element.scrollIntoView({ behavior: 'smooth' });
                }
              }}
            >
              Start Your Project
            </motion.button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Portfolio;

